import { Record as record } from 'immutable';

import trainTime from '../lib/TrainTime';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';
import { serialize, serializers } from '../helpers/SearchUrls';

const fieldSchema = {
    id: [fields.number],
    muteFrom: [resolve.with(trainTime), null],
    muteUntil: [resolve.with(trainTime), null],
};

class DisruptionAlertMute extends record(
    getDefaults(fieldSchema)
) {
    static fromJSON (json = {}) {
        return construct(DisruptionAlertMute, json, getResolvers(fieldSchema));
    }

    toJSON () {
        return serialize({
            muteId: (_, mute) => mute.id ? mute.id : null,
            muteFrom: muteFrom => muteFrom ? serializers.date(muteFrom) : null,
            muteUntil: muteUntil => muteUntil ? serializers.date(muteUntil) : null,
        }, this);
    }
}

export default DisruptionAlertMute;
